// extracted by mini-css-extract-plugin
module.exports = {"webform":"TableWebform_webform__4T232","toolbar":"TableWebform_toolbar__3Bht4","headerButton":"TableWebform_headerButton__VxS8m","spinner":"TableWebform_spinner__3D5uI"};